module.exports = __webpack_public_path__ + "img/tlz.4d2cdcff.png";